import React from "react";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {areaFormat, numberFormat, pluralize} from "@pg-mono/string-utils";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {VendorType} from "../../helpers/VendorType";
import {voivodeshipParser} from "../../helpers/VoivodeshipType";
import {IVendorDetailStatsRegions} from "../../types/IVendorDetailStatsRegions";

interface IProps {
    vendor: {
        description: string;
        headquarters: {
            type: 1 | 2;
            address: string;
            region: {
                id: number;
                name: string;
                name_declension_where: string;
            };
        };
        name: string;
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
        stats: {
            offers_count_for_sale: number;
            properties_commercials_area_max: number;
            properties_commercials_area_min: number;
            properties_flats_area_max: number;
            properties_flats_area_min: number;
            properties_houses_area_max: number;
            properties_houses_area_min: number;
            regions: Record<string, IVendorDetailStatsRegions>;
        };
        type: VendorType;
    };
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

const offersForSalePluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const getPropertiesAreaInfo = (areaMin: number, areaMax: number) => {
    return areaMin === areaMax ? `o metrażu ${areaFormat(areaMin)}` : `o metrażach od ${areaFormat(areaMin)} do ${areaFormat(areaMax)}`;
};

export const VendorDetailGeneratedDescription: React.FC<IProps> = ({vendor, flatsOffers, housesOffers, commercialsOffers}) => {
    const hasVendorFlatsForSale = flatsOffers.length > 0;
    const hasVendorHousesForSale = housesOffers.length > 0;
    const hasVendorCommercialsForSale = commercialsOffers.length > 0;

    return (
        <Text as="div" variant="body_copy_2">
            <p>
                {vendor.name} to jedna z ponad {numberFormat(5000)} firm w bazie {concatWithBrandName("portalu")}.
                {vendor.headquarters && ` Jej siedziba znajduje się ${vendor.headquarters.region.name_declension_where}.`}
            </p>

            {hasVendorFlatsForSale || hasVendorHousesForSale || hasVendorCommercialsForSale ? (
                <>
                    <p>
                        W swojej ofercie {vendor.type === VendorType.AGENCY ? "agencja nieruchomości" : "deweloper"} {vendor.name} posiada:
                    </p>

                    <ul>
                        {hasVendorFlatsForSale && (
                            <li>
                                Mieszkania na sprzedaż {getPropertiesAreaInfo(vendor.stats.properties_flats_area_min, vendor.stats.properties_flats_area_max)}.
                            </li>
                        )}

                        {hasVendorHousesForSale && (
                            <li>Domy na sprzedaż {getPropertiesAreaInfo(vendor.stats.properties_houses_area_min, vendor.stats.properties_houses_area_max)}.</li>
                        )}

                        {hasVendorCommercialsForSale && (
                            <li>
                                Lokale użytkowe na sprzedaż{" "}
                                {getPropertiesAreaInfo(vendor.stats.properties_commercials_area_min, vendor.stats.properties_commercials_area_max)}.
                            </li>
                        )}
                    </ul>

                    <p css={[mb(3)]}>
                        {hasVendorFlatsForSale &&
                            `Mieszkania znajdują się w ${flatsOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                flatsOffers.length > 1 ? flatsOffers.map((offer) => offer.name && ` ${offer.name}`) : flatsOffers[0].name
                            }.`}
                        {hasVendorHousesForSale &&
                            `Domy znajdują się w ${housesOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                housesOffers.length > 1 ? housesOffers.map((offer) => offer.name && ` ${offer.name}`) : housesOffers[0].name
                            }.`}
                        {hasVendorCommercialsForSale &&
                            `Lokale użytkowe znajdują się w ${commercialsOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                commercialsOffers.length > 1 ? commercialsOffers.map((offer) => offer.name && ` ${offer.name}`) : commercialsOffers[0].name
                            }.`}
                        Każda inwestycja {vendor.name} posiada szereg udogodnień spełniających oczekiwania nawet najbardziej wymagających klientów.
                    </p>

                    <p>Aktualna liczba ofert w sprzedaży:</p>

                    <ul>
                        {Object.entries(vendor.stats.regions).map(
                            ([regionName, regionValue]) =>
                                regionValue.offers > 0 && (
                                    <li key={regionName}>
                                        {regionValue.properties} nieruchomości w województwie {voivodeshipParser(regionName)}.
                                    </li>
                                )
                        )}
                    </ul>

                    <p>
                        W celu uzyskania informacji o {offersForSalePluralize(vendor.stats.offers_count_for_sale)} skontaktuj się z {vendor.name}.
                    </p>
                </>
            ) : (
                <>
                    <p>Obecnie {vendor.name} nie prowadzi sprzedaży swoich nieruchomości na naszym portalu.</p>
                </>
            )}
        </Text>
    );
};
import React from "react";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {areaFormat, numberFormat, pluralize} from "@pg-mono/string-utils";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {VendorType} from "../../helpers/VendorType";
import {voivodeshipParser} from "../../helpers/VoivodeshipType";
import {IVendorDetailStatsRegions} from "../../types/IVendorDetailStatsRegions";

interface IProps {
    vendor: {
        description: string;
        headquarters: {
            type: 1 | 2;
            address: string;
            region: {
                id: number;
                name: string;
                name_declension_where: string;
            };
        };
        name: string;
        recommendation: {
            pzfd_member: number | null;
            stats: {
                label: number;
                value: number;
            }[];
        } | null;
        stats: {
            offers_count_for_sale: number;
            properties_commercials_area_max: number;
            properties_commercials_area_min: number;
            properties_flats_area_max: number;
            properties_flats_area_min: number;
            properties_houses_area_max: number;
            properties_houses_area_min: number;
            regions: Record<string, IVendorDetailStatsRegions>;
        };
        type: VendorType;
    };
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
    }[];
    housesOffers: {
        name: string;
    }[];
    commercialsOffers: {
        name: string;
    }[];
}

const offersForSalePluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const getPropertiesAreaInfo = (areaMin: number, areaMax: number) => {
    return areaMin === areaMax ? `o metrażu ${areaFormat(areaMin)}` : `o metrażach od ${areaFormat(areaMin)} do ${areaFormat(areaMax)}`;
};

export const VendorDetailGeneratedDescription: React.FC<IProps> = ({vendor, flatsOffers, housesOffers, commercialsOffers}) => {
    const hasVendorFlatsForSale = flatsOffers.length > 0;
    const hasVendorHousesForSale = housesOffers.length > 0;
    const hasVendorCommercialsForSale = commercialsOffers.length > 0;

    return (
        <Text as="div" variant="body_copy_2">
            <p>
                {vendor.name} to jedna z ponad {numberFormat(5000)} firm w bazie {concatWithBrandName("portalu")}.
                {vendor.headquarters && ` Jej siedziba znajduje się ${vendor.headquarters.region.name_declension_where}.`}
            </p>

            {hasVendorFlatsForSale || hasVendorHousesForSale || hasVendorCommercialsForSale ? (
                <>
                    <p>
                        W swojej ofercie {vendor.type === VendorType.AGENCY ? "agencja nieruchomości" : "deweloper"} {vendor.name} posiada:
                    </p>

                    <ul>
                        {hasVendorFlatsForSale && (
                            <li>
                                Mieszkania na sprzedaż {getPropertiesAreaInfo(vendor.stats.properties_flats_area_min, vendor.stats.properties_flats_area_max)}.
                            </li>
                        )}

                        {hasVendorHousesForSale && (
                            <li>Domy na sprzedaż {getPropertiesAreaInfo(vendor.stats.properties_houses_area_min, vendor.stats.properties_houses_area_max)}.</li>
                        )}

                        {hasVendorCommercialsForSale && (
                            <li>
                                Lokale użytkowe na sprzedaż{" "}
                                {getPropertiesAreaInfo(vendor.stats.properties_commercials_area_min, vendor.stats.properties_commercials_area_max)}.
                            </li>
                        )}
                    </ul>

                    <p css={[mb(3)]}>
                        {hasVendorFlatsForSale &&
                            `Mieszkania znajdują się w ${flatsOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                flatsOffers.length > 1 ? flatsOffers.map((offer) => offer.name && ` ${offer.name}`) : flatsOffers[0].name
                            }.`}
                        {hasVendorHousesForSale &&
                            `Domy znajdują się w ${housesOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                housesOffers.length > 1 ? housesOffers.map((offer) => offer.name && ` ${offer.name}`) : housesOffers[0].name
                            }.`}
                        {hasVendorCommercialsForSale &&
                            `Lokale użytkowe znajdują się w ${commercialsOffers.length > 1 ? "inwestycjach:" : "inwestycji:"} ${
                                commercialsOffers.length > 1 ? commercialsOffers.map((offer) => offer.name && ` ${offer.name}`) : commercialsOffers[0].name
                            }.`}
                        Każda inwestycja {vendor.name} posiada szereg udogodnień spełniających oczekiwania nawet najbardziej wymagających klientów.
                    </p>

                    <p>Aktualna liczba ofert w sprzedaży:</p>

                    <ul>
                        {Object.entries(vendor.stats.regions).map(
                            ([regionName, regionValue]) =>
                                regionValue.offers > 0 && (
                                    <li key={regionName}>
                                        {regionValue.properties} nieruchomości w województwie {voivodeshipParser(regionName)}.
                                    </li>
                                )
                        )}
                    </ul>

                    <p>
                        W celu uzyskania informacji o {offersForSalePluralize(vendor.stats.offers_count_for_sale)} skontaktuj się z {vendor.name}.
                    </p>
                </>
            ) : (
                <>
                    <p>Obecnie {vendor.name} nie prowadzi sprzedaży swoich nieruchomości na naszym portalu.</p>
                </>
            )}
        </Text>
    );
};
